import React from 'react';
// Components
import ManageMerch from 'components/common/ManageMerch';

const ManageOrganizationMerch: React.FC = () => {
  return <ManageMerch />;
};

export default ManageOrganizationMerch;
